import SectionHeader from '@/components/base/SectionHeader';

const tips = [
  {
    icon: 'ri-emotion-happy-line',
    title: '按心情选番',
    desc: '想被治愈就找催泪暖心作，想轻松就挑搞笑日常番，牛奶动漫库的标签帮你快速定位。',
  },
  {
    icon: 'ri-chat-smile-line',
    title: '一集入坑',
    desc: '很多治愈番节奏舒缓，建议先看一两集感受氛围，别急着因为开头慢就弃掉。',
  },
  {
    icon: 'ri-award-line',
    title: '冷门也精彩',
    desc: '评分高但热度低的作品往往更耐看，补番目录里的冷门板块藏着不少惊喜。',
  },
  {
    icon: 'ri-moon-line',
    title: '静下心来',
    desc: '治愈番适合放慢节奏观看，挑个安静的夜晚，配上热牛奶，体验加倍。',
  },
];

export default function TipsSection() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="补番小贴士"
          title="这样补番，治愈翻倍"
          description="几个实用小技巧，让温馨的观剧体验更完整。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="rounded-2xl bg-background-50 p-6 transition hover:-translate-y-1"
            >
              <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${tip.icon} text-2xl`}></i>
              </span>
              <h3 className="mb-2 text-base font-semibold text-foreground-950">{tip.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}